import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { MobileActionBar } from '@/components/generals/mobile-action-bar'
import { QuoteListPanel } from '@/components/generals/quote-list-panel'

export const Layout: FC<LayoutProps> = ({ children, heroTheme = 'light' }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[110] focus:rounded-full focus:bg-ink focus:px-5 focus:py-3 focus:text-sm focus:text-cream'
            >
                Skip to main content
            </a>

            <Header theme={heroTheme} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />
            <MobileActionBar />
            <QuoteListPanel />
        </div>
    )
}
